import { ClampToEdgeWrapping, RepeatWrapping } from "three";

/** Taille physique par défaut d'une tuile texture (mm) — carré source 1500×1500. */
export const DEFAULT_TEXTURE_TILE_MM = 1500;

/**
 * Taille de tuile (mm) pour le mapping UV / repeat, ou null si pas une texture image.
 */
export function getMaterialTextureTileMm(material) {
  if (!material || material.colorType !== "TEXTURE") return null;
  const size = Number(material.textureSize);
  return size > 0 ? size : DEFAULT_TEXTURE_TILE_MM;
}

/**
 * Une tuile centrée sur la pièce (UV 0.5 ± offset/tileSize) — pas de répétition.
 */
export function applyTextureTileRepeat(texture) {
  if (!texture) return;
  texture.wrapS = ClampToEdgeWrapping;
  texture.wrapT = ClampToEdgeWrapping;
  texture.repeat.set(1, 1);
  texture.offset.set(0, 0);
  texture.needsUpdate = true;
}

export function configureColorMap(texture) {
  applyTextureTileRepeat(texture);
}

export function configureNormalMap(texture) {
  applyTextureTileRepeat(texture);
}

export function getNormalUvScale(material) {
  const scale = material?.userData?.normalUvScale;
  return {
    x: Number(scale?.x) || 1,
    y: Number(scale?.y) || 1,
  };
}

/** Répétition UV de la normal map — plus la valeur est grande, plus le brossage est fin. */
export function applyNormalMapUvScale(texture, scaleX = 1, scaleY = 1) {
  if (!texture) return;
  const sx = Number(scaleX) || 1;
  const sy = Number(scaleY) || 1;
  if (sx !== 1 || sy !== 1) {
    texture.wrapS = RepeatWrapping;
    texture.wrapT = RepeatWrapping;
  } else {
    texture.wrapS = ClampToEdgeWrapping;
    texture.wrapT = ClampToEdgeWrapping;
  }
  texture.repeat.set(sx, sy);
  texture.needsUpdate = true;
}

/** Aligne la normal map sur les transforms UV de la couleur (wrap, repeat, rotation…). */
export function syncNormalMapFromColorMap(material) {
  if (!material?.normalMap) return;
  const { normalMap } = material;
  const { x: scaleX, y: scaleY } = getNormalUvScale(material);

  if (material.map) {
    const { map } = material;
    normalMap.wrapS = map.wrapS;
    normalMap.wrapT = map.wrapT;
    normalMap.repeat.set(map.repeat.x * scaleX, map.repeat.y * scaleY);
    normalMap.offset.copy(map.offset);
    normalMap.center.copy(map.center);
    normalMap.rotation = map.rotation;
  } else {
    applyNormalMapUvScale(normalMap, scaleX, scaleY);
  }

  normalMap.needsUpdate = true;
  material.needsUpdate = true;
}

export function applyMapRotation(texture, rotationRad) {
  if (!texture) return;
  texture.center.set(0.5, 0.5);
  texture.rotation = rotationRad;
  texture.needsUpdate = true;
}
